'use client';
import { appPublicConfig } from '@/configs/appPublicConfig';
import { NoticePage } from '@/shared/components/parts/NoticePage';
import { InputForm } from './InputForm';
import { useInquiry } from './index.hook';

export const Inquiry: React.FC = () => {
  const { state, sendInquiry, isSending } = useInquiry();

  return (
    <>
      {state.pageStatus === 'INIT' && <div />}
      {state.pageStatus === 'INPUT' && (
        <InputForm
          state={state}
          sendInquiry={sendInquiry}
          isSending={isSending}
        />
      )}
      {state.pageStatus === 'COMPLETE' && (
        <NoticePage
          title="お問い合わせを受け付けました。"
          texts={[
            'ご指定のメールアドレスに回答を送信します。',
            '回答までに数日かかる場合があります。今しばらくお待ちください。',
          ]}
          links={[
            {
              href: appPublicConfig.ACCOUNT,
              text: 'ホーム',
            },
          ]}
        />
      )}
    </>
  );
};
